import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../service/authentication/login.service';

@Injectable({
  providedIn: 'root'
})
export class SessionGuard implements CanActivate {

  constructor(
    private LoginService: LoginService,
    private toastService: ToastrService,
    private router: Router
  ){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      return this.checkTokenSession();
  
    }
  
    checkTokenSession(): boolean {
  
      try {
  
        let status: boolean = true

        this.LoginService.verificaAutenticacion().subscribe({
          next: (resp: any) => {
            status = true
          },
          error: (error: any) => {
            status = false;

            localStorage.removeItem('token')

            this.toastService.warning('La sesión ha expirado, por favor, vuelve a iniciar sesión.');
    
            this.router.navigate(['authentication/login']);
          }
        })
  
        return status;
  
      } catch (error) {
  
        return false;
  
      }
  
    }
}
